export default class ComponenteNumericoSubtiposEnum {
    static DataId = 1
    static MoedaId = 2
    static HorarioId = 3
    static CepId = 4
    static CpfId = 5
    static CnpjId = 6
    static TelefoneId = 7
    static NumeroSimplesId = 8
}
